// extracted by mini-css-extract-plugin
export default {"container":"Game_container__E7+Tv","game":"Game_game__yK8IN","grid":"Game_grid__-Frmc","debug":"Game_debug__YzNG3","bottom":"Game_bottom__f29RA","error":"Game_error__c56FR"};